import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Paper, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ContainedButton } from "components/ContainedButton";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { CURRENT_PATH } from "utils/constants";

const useStyles = makeStyles((theme: any) => ({
  alertLink: {
    fontWeight: 'bold',
    textDecoration: 'none',
    width: "100%",
    marginTop: "1rem",
  },
  alertLinkIcon: { marginLeft: theme.spacing(0.7) },
  noDataFoundText: {
    fontWeight: 500,
    color: theme.palette.text.primary,
    fontSize: theme.typography.h4.fontSize,
  },
  icon: {
    height: "10rem !important",
    width: "10rem !important",
    color: theme.palette.tab.offselected
  },
  paper: {
    width: "100%", height: "100%", padding: "2rem", display: "flex", justifyContent: "center", alignItems: "center"
  },
  container: {
    display: "flex", flexDirection: "column", alignItems: "center", width: "35rem", gap: "0.7rem"
  },
  contentContainer: {
    marginTop: "1rem", height: "65vh"
  },
  titleContainer: {
    fontSize: "1rem", textAlign: "center"
  }
}));

export const PartyNotInvolved = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();

  return (
    <Box className={classes.contentContainer}>
      <Paper className={classes.paper}>
        <Box className={classes.container}>
          <FontAwesomeIcon icon="times-circle" className={classes.icon} />
          <Typography className={classes.noDataFoundText}>{t('orders:partyNotInvolvedTitle')}</Typography>
          <Typography className={classes.titleContainer}>
            {t('orders:partyNotInvolvedMessage')}
          </Typography>
          <Link
            to={`/orders/details/${id}/parties/`}
            className={classes.alertLink}
            onClick={() => {
              localStorage.setItem(
                CURRENT_PATH,
                JSON.stringify({ view: 'parties' })
              );
            }}
          >
            <ContainedButton text={t('orders:goToPartiesButton')} width="100%" height="2.5rem" />
          </Link>
        </Box>
      </Paper>
    </Box>
  );
};
